import { FaWhatsapp } from "react-icons/fa";

export const WhatsAppButton = () => {
  const Icon = FaWhatsapp as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

  return (
    <a
      href="https://wa.me/919699985688"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="group fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.5)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_36px_rgba(37,211,102,0.65)]"
    >
      <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366] opacity-30" />
      <Icon fontSize={30} />
      <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white opacity-0 shadow-lg transition-opacity duration-200 group-hover:opacity-100">
        Chat with us
      </span>
    </a>
  );
};
